<div class="sync-error-component-container page-root-container">
        <div class="page-header">
                <div class="page-title">

                        <img class="icon" src="assets/images/menu/svg/syn-error.svg"><span class="title">Sync Queue</span>
                </div>
                
        </div>

        <div class="data-container ">
                <app-loader [show]="isLoading"></app-loader>

                <!--               
                <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
                        [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                        [hidePageSize]="true">
                </app-search-filter> -->
                <app-search-filter  [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
                        [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                        [hidePageSize]="true" [enableCustFilter]="true"  [hideAdvancedFilter]="true">
                </app-search-filter>
                <!-- <ng-container *ngIf="pagingData.length>0; else nodata"> -->
                <!-- @if(pagingData.length > 0){
                                @if(!isHandset){ -->

                <section tabindex="0" class="table-container">
                        <table matSort mat-table [dataSource]="dataSource">
                                <ng-container matColumnDef="item">
                                        <th mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                                                class="item-header">#</th>
                                        <td mat-cell *matCellDef="let sync; let i = index" class="item-column">{{
                                                (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                                </ng-container> (matSortChange)="sortData($event)"

                                <ng-container matColumnDef="table_name">
                                        <th mat-sort-header="table_name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Module  </th>
                                        <td mat-cell *matCellDef="let sync"> {{sync.table_name}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="shop_name">
                                        <th mat-sort-header="shop_name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Shop Name </th>
                                        <td mat-cell *matCellDef="let sync"> {{sync.shop_name}}
                                        </td>
                                </ng-container>
                               
                                     <ng-container matColumnDef="crud_action">
    <th mat-sort-header="crud_action" mat-header-cell *matHeaderCellDef 
        (click)="sortData($event)" class="status-header"> Action </th>
    
        <td mat-cell *matCellDef="let sync">
                <div class="crud-action-status">
                        <div class="status" [ngClass]="sync.crud_action?.toLowerCase()">{{ sync.crud_action }}</div>
                </div>
        </td>
</ng-container>
<ng-container matColumnDef="sync_status">
    <th mat-sort-header="sync_status" mat-header-cell *matHeaderCellDef (click)="sortData($event)" class="status-header"> Status </th>
        <td mat-cell *matCellDef="let sync">
                <div class="crud-action-status status-flex-align">
                        <ng-container *ngIf="sync.sync_status === 'Waiting'">
                                <div class="sync-status-pill waiting">Waiting</div>
                        </ng-container>
                        <ng-container *ngIf="sync.sync_status === 'Error'">
                                <div class="sync-status-pill error clickable-pill" (click)="showErrorMessage(sync); $event.stopPropagation()">
                                        Error
                                        <span class="popup-icon" (click)="showErrorMessage(sync); $event.stopPropagation()" style="cursor:pointer; display:inline-flex; align-items:center; margin-left:6px;">
                                                <img src="assets/images/icons/popup.svg" alt="Show error details" width="18" height="18" />
                                        </span>
                                </div>
                        </ng-container>
                </div>
        </td>
</ng-container>

                                 
                                

                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                                </tr>
                                <tr mat-row class="table-element-row" *matRowDef="let sync; columns: displayedColumns;"
                                       
                                        [ngClass]=" {'row-selected' : sync.id===selectedItem?.id}">
                                </tr>
                        </table>
                </section>

                <!-- </ng-container> -->
                <!-- <ng-template #nodata> -->
                @if(pagingData.length<=0){ <div class="no-data-container">
                        <img src="assets/images/no-data.png">
                        <span class="no-data-info">No data found. Please remove or redefine the filters if
                                any.</span>
        </div>

        <!-- </ng-template> -->
        }
</div>

</div>
<ng-template #errorDialog>
  <h2 mat-dialog-title class="dialog-header">Sync Error Details</h2>
  <mat-dialog-content class="dialog-body">
    <p>{{ selectedErrorMsg }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="btn-close">Close</button>
  </mat-dialog-actions>
</ng-template>